import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/content";

export const Faq = () => {
  return (
    <section id="faq" className="py-20 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">FAQ</span>
          <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Domande frequenti
          </h1>
          <p className="mt-4 font-body text-base sm:text-lg text-ink">
            Hai altri dubbi? Chiedi pure ad Asia, la nostra assistente AI in basso a destra.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-gray-100 bg-white px-5 shadow-sm"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading text-left text-lg font-semibold text-brand-deep hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="font-body text-ink leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
